import React from 'react'
import HomeStore from '../../../components /ProductPage/ItemsProduct/HomeProduct'

const HomePage = () => {
  return (
    <div>
      <HomeStore />
    </div>
  )
}

export default HomePage
